'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var BoxReset_treat = require('./BoxReset.treat.js');
var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));
var _objectWithoutProperties = _interopDefault(require('@babel/runtime/helpers/objectWithoutProperties'));
var React = require('react');
var React__default = _interopDefault(React);
var classnames = _interopDefault(require('classnames'));
var PropTypes = _interopDefault(require('prop-types'));
var common_treat = require('../../util/commonStyles/common.treat.js');
var Box_treat = require('./Box.treat.js');
var commonEnums = require('../../util/commonStyles/enums/commonEnums.js');

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/**
 * Box
 *
 * @visibleName
 * @see Added: v6.0.0, Last updated: v6.3.0
 */

var Box = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var as = _ref.as,
      children = _ref.children,
      margin = _ref.margin,
      marginTop = _ref.marginTop,
      marginLeft = _ref.marginLeft,
      marginRight = _ref.marginRight,
      marginBottom = _ref.marginBottom,
      padding = _ref.padding,
      paddingTop = _ref.paddingTop,
      paddingRight = _ref.paddingRight,
      paddingLeft = _ref.paddingLeft,
      paddingBottom = _ref.paddingBottom,
      display = _ref.display,
      width = _ref.width,
      maxWidth = _ref.maxWidth,
      minWidth = _ref.minWidth,
      height = _ref.height,
      maxHeight = _ref.maxHeight,
      minHeight = _ref.minHeight,
      verticalAlign = _ref.verticalAlign,
      overflow = _ref.overflow,
      overflowX = _ref.overflowX,
      overflowY = _ref.overflowY,
      alignItems = _ref.alignItems,
      alignContent = _ref.alignContent,
      justifyContent = _ref.justifyContent,
      flexWrap = _ref.flexWrap,
      flexBasis = _ref.flexBasis,
      flexDirection = _ref.flexDirection,
      flex = _ref.flex,
      alignSelf = _ref.alignSelf,
      order = _ref.order,
      flexGrow = _ref.flexGrow,
      flexShrink = _ref.flexShrink,
      color = _ref.color,
      backgroundColor = _ref.backgroundColor,
      opacity = _ref.opacity,
      zIndex = _ref.zIndex,
      top = _ref.top,
      right = _ref.right,
      left = _ref.left,
      bottom = _ref.bottom,
      position = _ref.position,
      borderWidth = _ref.borderWidth,
      borderTopWidth = _ref.borderTopWidth,
      borderBottomWidth = _ref.borderBottomWidth,
      borderLeftWidth = _ref.borderLeftWidth,
      borderRightWidth = _ref.borderRightWidth,
      borderStyle = _ref.borderStyle,
      borderTopStyle = _ref.borderTopStyle,
      borderBottomStyle = _ref.borderBottomStyle,
      borderLeftStyle = _ref.borderLeftStyle,
      borderRightStyle = _ref.borderRightStyle,
      borderColor = _ref.borderColor,
      borderTopColor = _ref.borderTopColor,
      borderBottomColor = _ref.borderBottomColor,
      borderLeftColor = _ref.borderLeftColor,
      borderRightColor = _ref.borderRightColor,
      borderRadius = _ref.borderRadius,
      borderTopLeftRadius = _ref.borderTopLeftRadius,
      borderTopRightRadius = _ref.borderTopRightRadius,
      borderBottomLeftRadius = _ref.borderBottomLeftRadius,
      borderBottomRightRadius = _ref.borderBottomRightRadius,
      boxShadow = _ref.boxShadow,
      textAlign = _ref.textAlign,
      style = _ref.style,
      className = _ref.className,
      restProps = _objectWithoutProperties(_ref, ["as", "children", "margin", "marginTop", "marginLeft", "marginRight", "marginBottom", "padding", "paddingTop", "paddingRight", "paddingLeft", "paddingBottom", "display", "width", "maxWidth", "minWidth", "height", "maxHeight", "minHeight", "verticalAlign", "overflow", "overflowX", "overflowY", "alignItems", "alignContent", "justifyContent", "flexWrap", "flexBasis", "flexDirection", "flex", "alignSelf", "order", "flexGrow", "flexShrink", "color", "backgroundColor", "opacity", "zIndex", "top", "right", "left", "bottom", "position", "borderWidth", "borderTopWidth", "borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderStyle", "borderTopStyle", "borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderColor", "borderTopColor", "borderBottomColor", "borderLeftColor", "borderRightColor", "borderRadius", "borderTopLeftRadius", "borderTopRightRadius", "borderBottomLeftRadius", "borderBottomRightRadius", "boxShadow", "textAlign", "style", "className"]);

  var inlineCSSProp = {
    width: width,
    maxWidth: maxWidth,
    height: height,
    maxHeight: maxHeight,
    minWidth: minWidth,
    minHeight: minHeight,
    color: color,
    backgroundColor: backgroundColor,
    zIndex: zIndex,
    top: top,
    right: right,
    left: left,
    bottom: bottom,
    borderColor: borderColor,
    borderTopColor: borderTopColor,
    borderBottomColor: borderBottomColor,
    borderLeftColor: borderLeftColor,
    borderRightColor: borderRightColor,
    boxShadow: boxShadow
  };
  return /*#__PURE__*/React.createElement(as, _objectSpread({
    className: classnames(as !== null && BoxReset_treat.base, as !== null && BoxReset_treat.element[as], Box_treat.margin[margin], Box_treat.marginTop[marginTop], Box_treat.marginLeft[marginLeft], Box_treat.marginRight[marginRight], common_treat.marginBottom[marginBottom], Box_treat.padding[padding], Box_treat.paddingTop[paddingTop], Box_treat.paddingRight[paddingRight], Box_treat.paddingLeft[paddingLeft], Box_treat.paddingBottom[paddingBottom], Box_treat.display[display], Box_treat.verticalAlign[verticalAlign], Box_treat.overflow[overflow], Box_treat.overflowX[overflowX], Box_treat.overflowY[overflowY], Box_treat.alignItems[alignItems], Box_treat.alignContent[alignContent], Box_treat.justifyContent[justifyContent], Box_treat.flex[flex], Box_treat.flexBasis[flexBasis], Box_treat.flexWrap[flexWrap], Box_treat.flexGrow[flexGrow], Box_treat.flexShrink[flexShrink], Box_treat.flexDirection[flexDirection], Box_treat.alignSelf[alignSelf], Box_treat.order[order], Box_treat.opacity[opacity], Box_treat.position[position], Box_treat.borderWidth[borderWidth], Box_treat.borderTopWidth[borderTopWidth], Box_treat.borderBottomWidth[borderBottomWidth], Box_treat.borderLeftWidth[borderLeftWidth], Box_treat.borderRightWidth[borderRightWidth], Box_treat.borderStyle[borderStyle], Box_treat.borderTopStyle[borderTopStyle], Box_treat.borderBottomStyle[borderBottomStyle], Box_treat.borderLeftStyle[borderLeftStyle], Box_treat.borderRightStyle[borderRightStyle], common_treat.borderRadius[borderRadius], Box_treat.borderTopLeftRadius[borderTopLeftRadius], Box_treat.borderTopRightRadius[borderTopRightRadius], Box_treat.borderBottomLeftRadius[borderBottomLeftRadius], Box_treat.borderBottomRightRadius[borderBottomRightRadius], Box_treat.textAlign[textAlign], className),
    style: _objectSpread(_objectSpread({}, inlineCSSProp), style),
    ref: ref
  }, restProps), children);
});
process.env.NODE_ENV !== "production" ? Box.propTypes
/* remove-proptypes */
= {
  /**
   * @since Version v6.2.0
   *
   * The box type. Can be any html element type.
   *
   */
  as: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),

  /**
   * @since Version v6.2.0
   *
   * Children of this component
   *
   */
  children: PropTypes.node,

  /**
   *
   * The margin CSS property sets the margin area on all four sides of an element
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/margin)
   *
   * Options: xxTiny: 0.2rem, xTiny: 0.4rem, tiny: 0.8rem, xs: 1.2rem, sm: 1.6rem, md: 2.0rem, lg: 2.4rem, xl: 3.2rem, xxl: 4.8rem, clear: 0,
   *
   * @since Version v6.2.0
   *
   * @type {String}
   *
   */
  margin: PropTypes.oneOf(commonEnums.spacingEnums),

  /**
   * The margin-top CSS property sets the margin area on the top of an element.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/margin-top)
   *
   * Options: xxTiny: 0.2rem, xTiny: 0.4rem, tiny: 0.8rem, xs: 1.2rem, sm: 1.6rem, md: 2.0rem, lg: 2.4rem, xl: 3.2rem, xxl: 4.8rem, clear: 0,
   *
   * @since Version v6.2.0
   *
   * @type {String}
   *
   */
  marginTop: PropTypes.oneOf(commonEnums.spacingEnums),

  /**
   *
   * The margin-left CSS property sets the margin area on the left of an element.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/margin-left)
   *
   * Options: xxTiny: 0.2rem, xTiny: 0.4rem, tiny: 0.8rem, xs: 1.2rem, sm: 1.6rem, md: 2.0rem, lg: 2.4rem, xl: 3.2rem, xxl: 4.8rem, clear: 0,
   *
   * @since Version v6.2.0
   *
   * @type {String}
   *
   */
  marginLeft: PropTypes.oneOf(commonEnums.spacingEnums),

  /**
   * The margin-right CSS property sets the margin area on the right of an element.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/margin-right)
   *
   * Options: xxTiny: 0.2rem, xTiny: 0.4rem, tiny: 0.8rem, xs: 1.2rem, sm: 1.6rem, md: 2.0rem, lg: 2.4rem, xl: 3.2rem, xxl: 4.8rem, clear: 0,
   *
   * @since Version v6.2.0
   *
   * @type {String}
   *
   */
  marginRight: PropTypes.oneOf(commonEnums.spacingEnums),

  /**
   *
   * The margin-bottom CSS property sets the margin area on the bottom of an element.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/margin-bottom)
   *
   * Options: xxTiny: 0.2rem, xTiny: 0.4rem, tiny: 0.8rem, xs: 1.2rem, sm: 1.6rem, md: 2.0rem, lg: 2.4rem, xl: 3.2rem, xxl: 4.8rem, clear: 0,
   *
   * @since Version v6.2.0
   *
   * @type {String}
   */
  marginBottom: PropTypes.oneOf(commonEnums.spacingEnums),

  /**
   * The padding CSS property sets the padding area on all four sides of an element.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/padding)
   *
   * Options: xxTiny: 0.2rem, xTiny: 0.4rem, tiny: 0.8rem, xs: 1.2rem, sm: 1.6rem, md: 2.0rem, lg: 2.4rem, xl: 3.2rem, xxl: 4.8rem, clear: 0,
   *
   * @since Version v6.2.0
   *
   * @type {String}
   *
   */
  padding: PropTypes.oneOf(commonEnums.spacingEnums),

  /**
   * The padding-top CSS property sets the height of the padding area on the top of an element.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/padding-top)
   *
   * Options: xxTiny: 0.2rem, xTiny: 0.4rem, tiny: 0.8rem, xs: 1.2rem, sm: 1.6rem, md: 2.0rem, lg: 2.4rem, xl: 3.2rem, xxl: 4.8rem, clear: 0,
   *
   * @since Version v6.2.0
   *
   * @type {String}
   *
   */
  paddingTop: PropTypes.oneOf(commonEnums.spacingEnums),

  /**
   * The padding-left CSS property sets the height of the padding area on the left of an element.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/padding-left)
   *
   * Options: xxTiny: 0.2rem, xTiny: 0.4rem, tiny: 0.8rem, xs: 1.2rem, sm: 1.6rem, md: 2.0rem, lg: 2.4rem, xl: 3.2rem, xxl: 4.8rem, clear: 0,
   *
   * @since Version v6.2.0
   *
   * @type {String}
   *
   */
  paddingLeft: PropTypes.oneOf(commonEnums.spacingEnums),

  /**
   * The padding-right CSS property sets the height of the padding area on the right of an element.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/padding-right)
   *
   * Options: xxTiny: 0.2rem, xTiny: 0.4rem, tiny: 0.8rem, xs: 1.2rem, sm: 1.6rem, md: 2.0rem, lg: 2.4rem, xl: 3.2rem, xxl: 4.8rem, clear: 0,
   *
   * @since Version v6.2.0
   *
   * @type {String}
   *
   */
  paddingRight: PropTypes.oneOf(commonEnums.spacingEnums),

  /**
   * The padding-bottom CSS property sets the height of the padding area on the bottom of an element.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/padding-bottom)
   *
   * Options: xxTiny: 0.2rem, xTiny: 0.4rem, tiny: 0.8rem, xs: 1.2rem, sm: 1.6rem, md: 2.0rem, lg: 2.4rem, xl: 3.2rem, xxl: 4.8rem, clear: 0,
   *
   * @since Version v6.2.0
   *
   * @type {String}
   *
   */
  paddingBottom: PropTypes.oneOf(commonEnums.spacingEnums),

  /**
   * The display CSS property defines the display type of an element, which consists of the two basic qualities
   * of how an element generates boxes — the outer display type defining how the box participates in flow layout,
   * and the inner display type defining how the children of the box are laid out.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/display)
   *
   * @since Version v6.2.0
   *
   * @type {OneOfString<none | flex | block | inline | inline-block | inline-flex>}
   *
   */
  display: PropTypes.oneOf(Box_treat.displayEnums),

  /**
   * @since Version v6.2.0
   *
   * <strong>Inline style</strong>
   * Please see the Alert at the top of the page for more information.
   *
   * The width CSS property sets an element's width
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/width)
   */
  width: PropTypes.string,

  /**
   * @since Version v6.2.0
   *
   * <strong>Inline style</strong>
   * Please see the Alert at the top of the page for more information.
   *
   * The max-width CSS property sets the maximum width of an element.
   * It prevents the used value of the width property from becoming larger than the value specified by max-width.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/max-width)
   *
   */
  maxWidth: PropTypes.string,

  /**
   * @since Version v6.2.0
   *
   * <strong>Inline style</strong>
   * Please see the Alert at the top of the page for more information.
   *
   * The min-width CSS property sets the minimum width of an element.
   * It prevents the used value of the width property from becoming smaller than the value specified for min-width.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/min-width)
   *
   */
  minWidth: PropTypes.string,

  /**
   * @since Version v6.2.0
   *
   * <strong>Inline style</strong>
   * Please see the Alert at the top of the page for more information.
   *
   * The height CSS property specifies the height of an element. By default, the property defines the height of the
   * content area. If box-sizing is set to border-box, however, it instead determines the height of the border area.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/height)
   *
   */
  height: PropTypes.string,

  /**
   * @since Version v6.2.0
   *
   * <strong>Inline style</strong>
   * Please see the Alert at the top of the page for more information.
   *
   * The max-height CSS property sets the maximum height of an element. It prevents the used value of the height
   * property from becoming larger than the value specified for max-height.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/max-height)
   *
   */
  maxHeight: PropTypes.string,

  /**
   * @since Version v6.2.0
   *
   * <strong>Inline style</strong>
   * Please see the Alert at the top of the page for more information.
   *
   * The min-height CSS property sets the minimum height of an element. It prevents the used value of the height
   * property from becoming smaller than the value specified for min-height.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/display)
   *
   */
  minHeight: PropTypes.string,

  /**
   * The vertical-align CSS property specifies sets vertical alignment of an inline or table-cell box.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/vertical-align)
   *
   * @since Version v6.2.0
   *
   * @type {OneOfString<baseline|top|middle|bottom|sub|text-top>}
   */
  verticalAlign: PropTypes.oneOf(Box_treat.verticalAlignEnums),

  /**
   *
   * The overflow CSS property sets what to do when an element's content is too big to fit in its block
   * formatting context. It is a shorthand for overflow-x and overflow-y.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/overflow)
   *
   * @since Version v6.2.0
   *
   * @type {OneOfString<visible|hidden|scroll|auto>}
   *
   */
  overflow: PropTypes.oneOf(Box_treat.overflowEnums),

  /**
   *
   * The overflow-x CSS property sets what shows when content overflows a block-level element's left
   * and right edges. This may be nothing, a scroll bar, or the overflow content.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/overflow-x)
   *
   * @since Version v6.2.0
   *
   * @type {OneOfString<visible|hidden|scroll|auto>}
   *
   */
  overflowX: PropTypes.oneOf(Box_treat.overflowEnums),

  /**
   *
   * The overflow-y CSS property sets what shows when content overflows a block-level element's top
   * and bottom edges. This may be nothing, a scroll bar, or the overflow content.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/overflow-y)
   *
   * @since Version v6.2.0
   *
   * @type {OneOfString<visible|hidden|scroll|auto>}
   *
   */
  overflowY: PropTypes.oneOf(Box_treat.overflowEnums),

  /**
   * @since Version v6.2.0
   *
   * The overflow-y CSS property sets what shows when content overflows a block-level element's top
   * and bottom edges. This may be nothing, a scroll bar, or the overflow content.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/overflow-y)
   */
  alignItems: PropTypes.oneOf(Box_treat.alignItemsEnums),

  /**
   *
   * The CSS align-content property sets how the browser distributes space between and around content items
   * along the cross-axis of a flexbox container, and the main-axis of a grid container.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/align-content)
   *
   * @since Version v6.2.0
   *
   * @type {OneOfString<start|center|space-between|space-around>}
   *
   */
  alignContent: PropTypes.oneOf(Box_treat.alignContentEnums),

  /**
   * The CSS justify-content property defines how the browser distributes space between and around content items
   * along the main-axis of a flex container, and the inline axis of a grid container.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/justify-content)
   *
   * @since Version v6.2.0
   *
   * @type {OneOfString<flex-start|flex-end|center|space-between|space-around|space-evenly>}
   */
  justifyContent: PropTypes.oneOf(Box_treat.justifyContentEnums),

  /**
   * The flex-wrap CSS property sets whether flex items are forced onto one line or can wrap onto multiple lines.
   * If wrapping is allowed, it sets the direction that lines are stacked.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/flex-wrap)
   *
   * @since Version v6.2.0
   *
   * @type {OneOfString<nowrap|wrap|wrap-reverse>}
   *
   */
  flexWrap: PropTypes.oneOf(Box_treat.flexWrapEnums),

  /**
   *
   * The flex-basis CSS property sets the initial main size of a flex item
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/flex-basis)
   *
   * @since Version v6.2.0
   *
   * @type {OneOfString<0|auto>}
   *
   */
  flexBasis: PropTypes.oneOf(Box_treat.flexBasisEnums),

  /**
   *
   * The flex-direction CSS property specifies how flex items are placed in the flex container defining the main
   * axis and the direction (normal or reversed).
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/flex-direction)
   *
   * @since Version v6.2.0
   *
   * @type {OneOfString<row|row-reverse|column|column-reverse>}
   *
   */
  flexDirection: PropTypes.oneOf(Box_treat.flexDirectionEnums),

  /**
   *
   * The flex CSS property specifies how a flex item will grow or shrink so as to fit the space available in
   * its flex container. This is a shorthand property that sets flex-grow, flex-shrink, and flex-basis.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/flex)
   *
   * @since Version v6.2.0
   *
   * @type {OneOfString<initial|auto|none|1>}
   */
  flex: PropTypes.oneOf(Box_treat.flexEnums),

  /**
   *
   * The align-self CSS property aligns flex items of the current flex line overriding the align-items value.
   *
   * If any of the item's cross-axis margin is set to auto, then align-self is ignored. In Grid layout align-self
   * aligns the item inside the grid area.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/align-self)
   *
   * @since Version v6.2.0
   *
   * @type {OneOfString<stretch|center|start|end|flex-end>}
   *
   */
  alignSelf: PropTypes.oneOf(Box_treat.alignSelfEnums),

  /**
   *
   * The order CSS property sets the order to lay out an item in a flex or grid container. Items in a container
   * are sorted by ascending order value and then by their source code order.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/order)
   *
   * @since Version v6.2.0
   *
   * @type {OneOfString<0|1|2|3>}
   */
  order: PropTypes.oneOf(Box_treat.orderEnums),

  /**
   * The flex-grow CSS property sets the flex grow factor of a flex item main size. It specifies how much of the
   * remaining space in the flex container should be assigned to the item (the flex grow factor).
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/flex-grow)
   *
   * @since Version v6.2.0
   *
   * @type {OneOfString<0|1|2|3>}
   *
   */
  flexGrow: PropTypes.oneOf(Box_treat.flexGrowShrinkEnums),

  /**
   *
   * The flex-shrink CSS property sets the flex shrink factor of a flex item. If the size of all flex items is larger
   * than the flex container, items shrink to fit according to flex-shrink.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/flex-shrink)
   *
   * @since Version v6.2.0
   *
   * @type {OneOfString<0|1|2|3>}
   */
  flexShrink: PropTypes.oneOf(Box_treat.flexGrowShrinkEnums),

  /**
   * @since Version v6.2.0
   *
   * <strong>Inline style</strong>
   * Please see the Alert at the top of the page for more information.
   *
   * The color property sets the foreground color value of an element's text and text decorations
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/color)
   *
   */
  color: PropTypes.string,

  /**
   * @since Version v6.2.0
   *
   * <strong>Inline style</strong>
   * Please see the Alert at the top of the page for more information.
   *
   * The backgroundColor property sets the background color of an element
   *
   * [MDN Reference](https://developer.mozilla.org/en-US/docs/Web/CSS/background-color)
   *
   */
  backgroundColor: PropTypes.string,

  /**
   * The opacity CSS property sets the transparency of an element or the degree to which content
   * behind an element is visible.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/opacity)
   *
   * Options: xxs: 0.11, xs: 0.17, sm: 0.28, md: 0.5, lg: 0.72, xl: 0.83, xxl: 1, clear: 0,
   *
   * @since Version v6.2.0
   *
   * @type {String}
   *
   */
  opacity: PropTypes.oneOf(Box_treat.opacityEnums),

  /**
   * @since Version v6.2.0
   *
   * The z-index CSS property sets the z-order of a positioned element and its descendants or
   * flex items. Overlapping elements with a larger z-index cover those with a smaller one.
   *
   * <strong>Inline style</strong>
   * Please see the Alert at the top of the page for more information.
   *
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/z-index)
   */
  zIndex: PropTypes.number,

  /**
   * @since Version v6.2.0
   *
   * <strong>Inline style</strong>
   * Please see the Alert at the top of the page for more information.
   *
   * The top CSS property participates in specifying the vertical position of a
   * positioned element. It has no effect on non-positioned elements.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/top)
   *
   */
  top: PropTypes.string,

  /**
   * @since Version v6.2.0
   *
   * <strong>Inline style</strong>
   * Please see the Alert at the top of the page for more information.
   *
   * The right CSS property participates in specifying the horizontal position of a
   * positioned element. It has no effect on non-positioned elements.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/right)
   *
   */
  right: PropTypes.string,

  /**
   * @since Version v6.2.0
   *
   * <strong>Inline style</strong>
   * Please see the Alert at the top of the page for more information.
   *
   * The bottom CSS property participates in specifying the vertical position of a
   * positioned element. It has no effect on non-positioned elements.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/top)
   *
   */
  bottom: PropTypes.string,

  /**
   * @since Version v6.2.0
   *
   * <strong>Inline style</strong>
   * Please see the Alert at the top of the page for more information.
   *
   * The left CSS property participates in specifying the horizontal position
   * of a positioned element. It has no effect on non-positioned elements.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/left)
   *
   */
  left: PropTypes.string,

  /**
   *
   * The position CSS property specifies how an element is positioned in a document.
   * The top, right, bottom, and left properties determine the final location of positioned elements.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/position)
   *
   * @since Version v6.2.0
   *
   * @type {OneOfString<static|relative|absolute|sticky|fixed>}
   */
  position: PropTypes.oneOf(Box_treat.positionEnums),

  /**
   *
   * The border-width shorthand CSS property sets the width of all sides of an element's border.
   *
   * [MDN * reference](https://developer.mozilla.org/en-US/docs/Web/CSS/border-width)
   *
   * Options: thin: 1px, thick: 2px, clear: 0
   *
   * @since Version v6.2.0
   *
   * @type {String}
   */
  borderWidth: PropTypes.oneOf(Box_treat.borderWidthEnums),

  /**
   *
   * The border-top-width CSS property sets the width of the top border of an element.
   *
   * [MDN * reference](https://developer.mozilla.org/en-US/docs/Web/CSS/border-top-width)
   *
   * Options: thin: 1px, thick: 2px, clear: 0
   *
   * @since Version v6.2.0
   *
   * @type {String}
   */
  borderTopWidth: PropTypes.oneOf(Box_treat.borderWidthEnums),

  /**
   *
   * The border-bottom-width CSS property sets the width of the bottom border of an element.
   *
   * [MDN * reference](https://developer.mozilla.org/en-US/docs/Web/CSS/border-bottom-width)
   *
   * Options: thin: 1px, thick: 2px, clear: 0
   *
   * @since Version v6.2.0
   *
   * @type {String}
   */
  borderBottomWidth: PropTypes.oneOf(Box_treat.borderWidthEnums),

  /**
   *
   * The border-left-width CSS property sets the width of the left border of an element.
   *
   * [MDN * reference](https://developer.mozilla.org/en-US/docs/Web/CSS/border-left-width)
   *
   * Options: thin: 1px, thick: 2px, clear: 0
   *
   * @since Version v6.2.0
   *
   * @type {String}
   */
  borderLeftWidth: PropTypes.oneOf(Box_treat.borderWidthEnums),

  /**
   *
   * The border-right-width CSS property sets the width of the right border of an element.
   *
   * [MDN * reference](https://developer.mozilla.org/en-US/docs/Web/CSS/border-right-width)
   *
   * Options: thin: 1px, thick: 2px, clear: 0
   *
   * @since Version v6.2.0
   *
   * @type {String}
   */
  borderRightWidth: PropTypes.oneOf(Box_treat.borderWidthEnums),

  /**
   *
   * The border-style shorthand CSS property sets the style of all sides of an element's border.
   *
   * [MDN * reference](https://developer.mozilla.org/en-US/docs/Web/CSS/border-style)
   *
   * Options: none, hidden, dotted, dashed, solid, double, groove, ridge, inset, outset
   *
   * @since Version v6.2.0
   *
   * @type {String}
   */
  borderStyle: PropTypes.oneOf(Box_treat.borderStyleEnums),

  /**
   *
   * The border-top-style CSS property sets the line style of an element's top border.
   *
   * [MDN * reference](https://developer.mozilla.org/en-US/docs/Web/CSS/border-top-style)
   *
   * Options: none, hidden, dotted, dashed, solid, double, groove, ridge, inset, outset
   *
   * @since Version v6.2.0
   *
   * @type {String}
   */
  borderTopStyle: PropTypes.oneOf(Box_treat.borderStyleEnums),

  /**
   *
   * The border-bottom-style CSS property sets the line style of an element's bottom border.
   *
   * [MDN * reference](https://developer.mozilla.org/en-US/docs/Web/CSS/border-bottom-style)
   *
   * Options: none, hidden, dotted, dashed, solid, double, groove, ridge, inset, outset
   *
   * @since Version v6.2.0
   *
   * @type {String}
   */
  borderBottomStyle: PropTypes.oneOf(Box_treat.borderStyleEnums),

  /**
   *
   * The border-left-style CSS property sets the line style of an element's left border.
   *
   * [MDN * reference](https://developer.mozilla.org/en-US/docs/Web/CSS/border-left-style)
   *
   * Options: none, hidden, dotted, dashed, solid, double, groove, ridge, inset, outset
   *
   * @since Version v6.2.0
   *
   * @type {String}
   */
  borderLeftStyle: PropTypes.oneOf(Box_treat.borderStyleEnums),

  /**
   *
   * The border-right-style CSS property sets the line style of an element's right border.
   *
   * [MDN * reference](https://developer.mozilla.org/en-US/docs/Web/CSS/border-right-style)
   *
   * Options: none, hidden, dotted, dashed, solid, double, groove, ridge, inset, outset
   *
   * @since Version v6.2.0
   *
   * @type {String}
   */
  borderRightStyle: PropTypes.oneOf(Box_treat.borderStyleEnums),

  /**
   * @since Version v6.2.0
   *
   * <strong>Inline style</strong>
   * Please see the Alert at the top of the page for more information.
   *
   * The border-color shorthand CSS property sets the color of all sides of an element's border.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/border-color)
   *
   */
  borderColor: PropTypes.string,

  /**
   * @since Version v6.2.0
   *
   * <strong>Inline style</strong>
   * Please see the Alert at the top of the page for more information.
   *
   * The border-top-color CSS property sets the color of an element's top border. It can also be set with the shorthand CSS properties border-color or border-top.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/border-top-color)
   *
   */
  borderTopColor: PropTypes.string,

  /**
   * @since Version v6.2.0
   *
   * <strong>Inline style</strong>
   * Please see the Alert at the top of the page for more information.
   *
   * The border-bottom-color CSS property sets the color of an element's bottom border. It can also be set with the shorthand CSS properties border-color or border-bottom.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/border-bottom-color)
   *
   */
  borderBottomColor: PropTypes.string,

  /**
   * @since Version v6.2.0
   *
   * <strong>Inline style</strong>
   * Please see the Alert at the top of the page for more information.
   *
   * The border-left-color CSS property sets the color of an element's left border. It can also be set with the shorthand CSS properties border-color or border-left.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/border-left-color)
   *
   */
  borderLeftColor: PropTypes.string,

  /**
   * @since Version v6.2.0
   *
   * <strong>Inline style</strong>
   * Please see the Alert at the top of the page for more information.
   *
   * The border-right-color CSS property sets the color of an element's right border. It can also be set with the shorthand CSS properties border-color or border-right.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/border-right-color)
   *
   */
  borderRightColor: PropTypes.string,

  /**
   *
   * The border-radius CSS property rounds the corners of an element's outer border edge. You can set a single
   * radius to make circular corners, or two radii to make elliptical corners.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/border-radius)
   *
   * Options: xs: 0.2rem, sm: 0.4rem, md: 0.8rem, lg: 1.2rem, xl: 2.4rem, clear: 0
   *
   * @since Version v6.2.0
   *
   * @type {String}
   */
  borderRadius: PropTypes.oneOf(commonEnums.borderRadiusEnums),

  /**
   *
   * The border-top-left-radius CSS property rounds the top-left corner of an element.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/border-top-left-radius)
   *
   * Options: xs: 0.2rem, sm: 0.4rem, md: 0.8rem, lg: 1.2rem, xl: 2.4rem, clear: 0
   *
   * @since Version v6.2.0
   *
   * @type {String}
   */
  borderTopLeftRadius: PropTypes.oneOf(commonEnums.borderRadiusEnums),

  /**
   *
   * The border-top-right-radius CSS property rounds the top-right corner of an element.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/border-top-right-radius)
   *
   * Options: xs: 0.2rem, sm: 0.4rem, md: 0.8rem, lg: 1.2rem, xl: 2.4rem, clear: 0
   *
   * @since Version v6.2.0
   *
   * @type {String}
   */
  borderTopRightRadius: PropTypes.oneOf(commonEnums.borderRadiusEnums),

  /**
   *
   * The border-bottom-left-radius CSS property rounds the bottom-left corner of an element.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/border-bottom-left-radius)
   *
   * Options: xs: 0.2rem, sm: 0.4rem, md: 0.8rem, lg: 1.2rem, xl: 2.4rem, clear: 0
   *
   * @since Version v6.2.0
   *
   * @type {String}
   */
  borderBottomLeftRadius: PropTypes.oneOf(commonEnums.borderRadiusEnums),

  /**
   *
   * The border-bottom-right-radius CSS property rounds the bottom-right corner of an element.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/border-bottom-right-radius)
   *
   * Options: xs: 0.2rem, sm: 0.4rem, md: 0.8rem, lg: 1.2rem, xl: 2.4rem, clear: 0
   *
   * @since Version v6.2.0
   *
   * @type {String}
   */
  borderBottomRightRadius: PropTypes.oneOf(commonEnums.borderRadiusEnums),

  /**
   * @since Version v6.2.0
   *
   * <strong>Inline style</strong>
   * Please see the Alert at the top of the page for more information.
   *
   * The box-shadow CSS property adds shadow effects around an element's frame. You can set multiple effects separated
   * by commas. A box shadow is described by X and Y offsets relative to the element, blur and spread radii and color.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/box-shadow)
   *
   */
  boxShadow: PropTypes.string,

  /**
   * @since Version v6.2.0
   *
   * The style props add an inline style to this component. Values specified through this props will override inline props
   * specified to in other props.
   *
   * For example:
   * `<Box backgroundColor='red' style={{backgroundColor: 'blue'}}/>` will produce a blue box and not a red box.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/box-shadow)
   *
   */
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.object,

  /**
   *
   * The text-align CSS property sets the horizontal alignment of a block element or table-cell box
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/text-align)
   *
   * @since Version v6.3.0
   *
   * @type {OneOfString<left|right|center|justify>}
   */
  textAlign: PropTypes.oneOf(Box_treat.textAlignEnums),

  /**
   * Specify your own classname into this prop, if you need to customise layout of this component.
   * This classname will be put into the parent container of this components
   *
   * @since Version v6.3.0
   */
  className: PropTypes.string
} : void 0;
Box.defaultProps = {
  as: 'div'
};
Box.displayName = 'Box';

exports.default = Box;
